import { API } from "@aws-amplify/api";

export async function fetchCounters() {
  return await API.get("API", "/counters", {});
}
